import React, {useState} from 'react'
// import datas from '../../../../datas/Datas.json'
import JobCard from '../../../../components/Cards/JobCard'

const Offer = ({item}) => {
    const [jobs, setJobs] = useState([])
  return (
    <div className='grid grid-cols-1 gap-y-4'>
       {item?.map((job)=>{
          return( 
            <JobCard key={job.id} item={job} />
            )
          
        })} 
    </div>
  )
}

export default Offer